import { OnInit, AfterViewInit, OnDestroy, ViewChild, Directive } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subject, takeUntil } from 'rxjs';
import { DestroyableComponent } from '../../shared/base/destroyable.component';
import { applyPageEvent, bindSortChange, bindDebouncedSearch } from '../../shared/utils/table-query.utils';

@Directive()
export abstract class BaseTableComponent<T> extends DestroyableComponent implements OnInit, AfterViewInit, OnDestroy {

  dataSource = new MatTableDataSource<T>([]);
  totalCount = 0;
  pageIndex = 0;
  pageSize = 10;
  sortBy = '';
  sortDir: 'asc' | 'desc' = 'asc';
  loading = false;
  errorMessage = '';
  searchTerm = '';
  search$ = new Subject<string>();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  abstract readonly displayedColumns: string[];

  ngOnInit(): void {
    this.initSearch();
    this.loadDataWrapper();
  }

  ngAfterViewInit(): void {
    this.initSort();
  }

  private initSearch(): void {
    bindDebouncedSearch(this.search$, this.destroy$, (term) => {
      this.searchTerm = term;
      this.pageIndex = 0;
      this.loadDataWrapper();
    });
  }

  private initSort(): void {
    if (!this.sortBy ) return;

    bindSortChange(this.sort, this.destroy$, this.sortBy, ({ sortBy, sortDir }) => {
      this.sortBy = sortBy;
      this.sortDir = sortDir;
      this.pageIndex = 0;
      this.loadDataWrapper(); 
    });
  }

  onSearch(value: string): void {
    this.search$.next(value);
  }

  clearSearch(): void {
    if (this.searchTerm) this.search$.next('');
  }

  onPageChange(event: PageEvent): void {
    const next = applyPageEvent(event);
    this.pageIndex = next.pageIndex;
    this.pageSize = next.pageSize;
    this.loadDataWrapper();
  }

  protected abstract loadData(skip: number, count: number): void;

  protected loadDataWrapper(): void {
    const skip = this.pageIndex * this.pageSize;
    const count = this.pageSize;
    this.loadData(skip, count);
  }
}